import { ReadRequest } from "~/backendApis/foundation/ReadRequest"
import { MessageListView } from "~/backendApis/viewModel/matching"

interface Params {
  universalCorporationId: string
  chatGroupId: string
  oldestMessageId: string | null
}

export class GetPastMessageListReadRequest extends ReadRequest<MessageListView> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public get(): Promise<MessageListView> {
    return this.apiClient.get(this.makeEndpoint())
  }

  private makeEndpoint(): string {
    const { universalCorporationId, chatGroupId, oldestMessageId } = this.params
    const query = oldestMessageId ? `?oldestMessageId=${oldestMessageId}` : ""
    return `/matching/corporation_member/${universalCorporationId}/chat_group/${chatGroupId}/message/past_list${query}`
  }
}
